import { calculatePersonalPayment } from '@atc/wallet-payment-fns';
const getFallbackPaymentObj = (isFinanceErrorState, walletDownPaymentFallBack, totalEquity, totalCashOut, udsLocalStateValues) => {
  const {
    selectedLoanTerm,
    selectedLeaseTerm,
    localInterestRate,
    financeDownPayment,
    localPrice,
    customRate
  } = udsLocalStateValues;
  const fallBackFinanceObj = {
    paymentLabel: 'finance',
    loanTerm: selectedLoanTerm,
    isPaymentError: isFinanceErrorState,
    interestRate: customRate || localInterestRate,
    downPayment: financeDownPayment || walletDownPaymentFallBack,
    lender: 'National Average Rate',
    payment: Math.max(0, calculatePersonalPayment(localPrice, {
      loanTerm: selectedLoanTerm,
      downPayment: financeDownPayment || walletDownPaymentFallBack,
      totalEquity
    }, customRate || localInterestRate))
  };
  const fallBackLeaseObj = {
    paymentLabel: 'lease',
    loanTerm: selectedLeaseTerm,
    isPaymentError: null
  };
  const fallBackCashObj = {
    paymentLabel: 'cash',
    loanTerm: selectedLoanTerm,
    payment: Math.max(0, totalCashOut)
  };
  return {
    fallBackFinanceObj,
    fallBackLeaseObj,
    fallBackCashObj
  };
};
export { getFallbackPaymentObj as default };
